<template>
<div class="warp">

<!-- <router-view></router-view> -->
  <div class="gerenzxone">
    <!-- 头部 -->
    <div class="gerenzxone-head">
      <div class="grone-head-col"></div>
      <!-- 个人信息 -->
      <div class="grone-head-xinxi">
        <div class="grone-head-xinxi-left">
          <!-- 个人头像 -->
          <div class="grone-xinxi-logo">
            <img :src="this.$apiUrl+staimg.head_img" alt="" />
          </div>
          <!-- 信息 -->
          <div class="grxinxi-all">
            <span class="grxinxi-all-name">{{xinxiname}}</span>
            <p>{{xinxijieshao}} {{twomsg}}</p>
          </div>
        </div>
        <!-- 上传视频按钮 -->
        
        <div v-show="uplodebtnshow" @click="uplode()" class="grone-xin-uplodo">
            <i>         
            </i>
            <span>上传作品</span>   
        </div>

      </div>
    </div>

      <!-- 左侧切换组件 -->
       <div  class="gerenzx">

      <!-- tab切换 -->
      <div v-show="typeuser"  class="gerenzx-tab">
          <div v-show="typeuser" class="gerenzx-tab-one">
              <span class="a"
              :class="active == activetwo ? 'gerentabstab':''"
               @click="toggleTab('gerenzxtwo'),awshow()">我的创作</span>
          </div>
        
          <div v-show="typeuser" class="gerenzx-tab-one">
              <span class="a" 
              :class="active == activetwoc ? 'gerentabstab':''"
                @click="toggleTab('gerenxinxi'),cwshow()">账户信息</span>
          </div>
     
          <div v-show="typeuser" class="gerenzx-tab-one">
    <span  class="a" :class="active == activetwod ? 'gerentabstab':''" @click="dwshow(),toggleTab('gerenrenz')">认证信息</span>
          </div>
      </div>
       
      <!-- 组件切换 -->
      <gerenzxtwo v-show="moren" :is="currentView"></gerenzxtwo>
      <gerenzxthree v-show="morentwo"></gerenzxthree>
      <gerenxinxi v-if="typesg == 1"></gerenxinxi>
  </div>
  
  </div>
  <botTom></botTom>
 </div> 
</template>

<script>
import GeRenzxone from "../css/GeRenzxone.css"
import GeRenzx from "../css/GeRenzx.css"
import gerenzxtwo from './GeRenzxtwo'
import gerenzx from './GeRenzx'
import gerenxinxi from './GeRenxinxi'
import gerenzxthree from './GeRenzxthree'
import gerenrenz from './GeRenrenz'
import gerenshenhe from './GeRenshenhe'
import botTom from './BotTom'
export default {
  data() {
    return {
         currentView:'gerenzxtwo',
         moren:true,
         morentwo:false,
         uplodebtnshow:true,
         typeone:false,
         xinxi:true,
         touxlogo:JSON.parse(localStorage.getItem("grxinxi")).head_img, //头像
         xinxiname:'',   //名字
         xinxijieshao:JSON.parse(localStorage.getItem("grxinxi")).work_unit,
         typeuser:true,
         typesg:JSON.parse(localStorage.getItem("userinfo")).type,
         twomsg:'',
         active:1,
         activetwo:1,
         activetwob:2,
         activetwoc:3,
         activetwod:4,
         bolupa:''
    };
  },
    mounted () {
      // 选项卡下标
     if (JSON.parse(localStorage.getItem('grxinxi')).status == -1) {
        let myTab = this.$route.query.myTab;
        this.currentView = myTab;
        if ( this.currentView = myTab) {
          this.active = 4;
        }
             
     }  
    let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状态
  let stutas = sessionStorage.getItem('status'); //作品审核状态
  // if (rzstutas == 1 && stutas == undefined || rzstutas == 1 && stutas == -1) {
  //  let zpBc = this.$route.query.zpBc;

  //  if (zpBc==1) {
  //  this.uplode();
  //  document.getElementsByClassName('gerenzxtwo')[0].style.display="none";
  //  }
  // }  
      
   
      this.grtypes();
      // 用户姓名展示
      if (JSON.parse(localStorage.getItem("grxinxi")).is_teacher == 0) {
        this.xinxiname = JSON.parse(localStorage.getItem("grxinxi")).nickname;
      }else if (JSON.parse(localStorage.getItem("grxinxi")).is_teacher == 1) {
          this.xinxiname = JSON.parse(localStorage.getItem("grxinxi")).name;
          this.twomsg = JSON.parse(localStorage.getItem("grxinxi")).message;
      }

 if (JSON.parse(localStorage.getItem("userinfo")).type == 1) {
   this.typeuser = false;
   this.xinxijieshao =JSON.parse(localStorage.getItem("grxinxi")).message;
 }else if (JSON.parse(localStorage.getItem("userinfo")).type == 2) {
   this.typeuser = true;
 }
    },
  computed:{
    staimg(){
      return this.$store.state.grxinxi
    }
  },
  components:{
  gerenzx,
  gerenzxtwo,
  gerenxinxi,
  gerenzxthree,
  gerenrenz,
  botTom,gerenshenhe
  },
  methods:{
    //  组件切换
toggleTab(tab){
this.currentView= tab;
this.morentwo = false;
this.moren = true;
this.$router.push({ name: "GeRenzxone"});
},
// 颜色切换
awshow(){
this.active = 1;
if (this.$store.state.userinfo.type==2) {
  this.uplodebtnshow = true;
}else if (this.$store.state.userinfo.type==1) {
  this.uplodebtnshow = false;
}
},
bwshow(){
this.active = 2;
this.uplodebtnshow = false;
},
cwshow(){
  this.active = 3;
this.uplodebtnshow = false;
},
dwshow(){
  this.active = 4;
this.uplodebtnshow = false;
},
// 点击上传视频
uplode(){
  let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状态
  let stutas = JSON.parse(sessionStorage.getItem('status')); //作品审核状态

  if (rzstutas == 0) {
    this.$message.error({
      message:'您的认证信息审核中，请耐心等待！！！',
      offset:200
    })
    return false
    
  }else if (stutas == 0) {
    this.$message.error({
      message:'作品审核中，请耐心等待！！！',
      offset:200
    })
    return false
    
  }else if (rzstutas == 1 && stutas == -1) {
    this.moren = false;
    this.morentwo = true;

  }else if (rzstutas == 1 && stutas == undefined) {
    this.moren = false;
    this.morentwo = true;
  }
  else if (rzstutas == -1) {
     this.$message.error({
       message:'您的信息认证失败，请前往认证信息模块重新提交！！！',
       offset:200
     })
      return false
  }else if (stutas == 1) {
     this.$message.error({
       message:'您已有优秀作品审核通过,请勿重复提交！！！',
       offset:200
     })
  }

},

// 判断用户type
grtypes(){
  let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
  
     if (this.$store.state.userinfo.type==1) {
       this.uplodebtnshow=false;  //上传视频按钮
       this.moren=false;
       this.xinxi=true;
       
     } else if (this.$store.state.userinfo.type==2) {
       this.uplodebtnshow=true;
       this.moren=true;
       this.typeone = true;
       this.xinxi=false;
     }else if (tokens=='' || this.$store.state.userinfo.type==null) {
     this.$router.push({path:"/denglu"});
     localStorage.clear();
     sessionStorage.clear();
}
    },
   
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/GeRenzxone.vue